import SkillsDisplay from './SkillsDisplay.jsx';

export default SkillsDisplay;
